const home = {
  hero: {
    title: 'One Systeme Caisse',
    subtitle: 'Vendez Facilement et Efficacement',
    description: 'Une solution unifiée pour gérer votre commerce. Transformez votre appareil en caisse enregistreuse professionnelle et accédez à toutes vos données où que vous soyez.',
    cta: 'Demander une démo'
  },
  features: {
    title: 'Une solution complète pour votre commerce',
    description: 'Découvrez nos fonctionnalités innovantes conçues pour simplifier la gestion de votre commerce. Une interface intuitive et des outils puissants pour optimiser vos ventes et votre productivité.',
    items: {
      touch: {
        title: '100% Tactile',
        description: 'Une interface entièrement tactile pour une utilisation intuitive et rapide. Gérez vos ventes et opérations avec un simple toucher.'
      },
      tickets: {
        title: 'Tickets',
        description: 'Système de facturation convivial pour un suivi et une gestion simplifiés des paiements.'
      },
      responsive: {
        title: '100% Responsive',
        description: 'Une interface qui s\'adapte parfaitement à tous les écrans, du smartphone à la tablette, pour une expérience utilisateur optimale sur tous les appareils.'
      },
      barcode: {
        title: 'Code-barres',
        description: 'Scanner rapide et précis des codes-barres pour une gestion efficace des stocks et des ventes. Compatible avec tous les types de codes-barres standards.'
      }
    }
  },
  quickStart: {
    title: 'Commencez à Utiliser PWA OS Caisse en Quelques Minutes',
    description: 'Une installation rapide et une prise en main intuitive vous permettent de démarrer immédiatement. Configurez votre caisse, importez vos produits et commencez à vendre en quelques clics.',
    items: {
      easy: 'Facile à utiliser',
      secure: '100% Sécurisé',
      backup: 'Sauvegarde automatique'
    }
  },
  businessTypes: {
    title: 'Solution Idéale pour Tous les Types de Commerce',
    types: [
      'Restaurant',
      'Café',
      'Fast Food',
      'Pâtisserie',
      'Prêt à porter',
      'Épicerie',
      'Soin & beauté',
      'Electronique',
      'Meubles & déco',
      'Bijouterie'
    ]
  },
  testimonials: {
    title: 'Témoignages des Marchands',
    rating: '4.4',
    reviews: '+3 000 avis sur Google Play Store',
    items: [
      {
        title: 'Solution complète',
        text: 'L\'utilisation de PWA OS Caisse répond parfaitement aux besoins de mon commerce, me permettant d\'atteindre un succès durable et un progrès remarquable.'
      },
      {
        title: 'Simplicité et efficacité',
        text: 'L\'interface conviviale et le fonctionnement fluide en font une solution efficace pour gérer mon commerce en toute simplicité.'
      },
      {
        title: 'Choix économique',
        text: 'La solution abordable m\'a offert une valeur exceptionnelle en m\'aidant à améliorer les opérations de mon commerce sans me ruiner.'
      }
    ]
  }
};

export default home; 